export const ONBOARDING_APP = '/app';
export const ONBOARDING_QUEST = '/quest';
export const ONBOARDING_WEEK = '/week';
